/**
 * Class component based on:
 * https://dev.to/megazear7/the-vanilla-javascript-component-pattern-37la
 */
import {selectDoc} from "../utils/utils";

export class Marquee {
    /**
     * Marquee Constructor
     * @param container
     * @returns {*}
     */
    constructor(container) {
        if (container) {
            this.init(container)
        }
    }

    /**
     * Initialize class
     * @param container
     */
    init(container) {
        this.container = container
        // after window is completed load
        // 1 class selector for marquee
        // 2 marquee speed 0.2
        window.addEventListener('load', this.marquee('.marquee__container', 0.2))
    }

    /**
     * Animate marquee
     */
     marquee(selector, speed) {
        const parentSelector = selectDoc(selector);
        const clone = parentSelector.innerHTML;
        const firstElement = parentSelector.children[0];
        const offset = 80;
        let i = 0;
    
        parentSelector.insertAdjacentHTML('beforeend', clone);
        parentSelector.insertAdjacentHTML('beforeend', clone);
        const limit = firstElement.clientWidth + offset;
        
        setInterval(function() {
          firstElement.style.marginLeft = `-${i}px`;
          if (i > limit) {
            i = 0;
          }
          i = i + speed;
        }, 0);
    }
}

